"use strict";

require("@patsnap-ui/icon/assets/Timer.svg");
require("@patsnap-biz/header-widget/lib/style");
require("@patsnap-biz/toast/lib/style");
require("@patsnap-biz/icon/lib/style");
require("@patsnap-biz/dialog/lib/style");
require("./index.scss");
require("./case-time");